import { z } from "zod";

export const steelAssemblyCreateInput = z
  .object({
    buildingId: z.string().min(1),
    zoneId: z.string().nullish(),
    batchId: z.string().nullish(),
    packageId: z.string().nullish(),
    note: z.string().nullish(),
    guandaId: z.number().int().nullish(),
    steelAssemblyId: z.string().nullish(),
    steelAssemblyCode: z.string().nullish(),
    installationLocation: z.string().nullish(),
    installationElevation: z.number().nullish(),
    distinction: z.string().nullish(),
    transportNumber: z.string().nullish(),
    transportDescription: z.string().nullish(),
    drawingName: z.string().nullish(),
    totalWidth: z.number().nullish(),
    totalHeight: z.number().nullish(),
    totalLength: z.number().nullish(),
    totalWeight: z.number().nullish(),
    totalArea: z.number().nullish(),
    metricSizeMark: z.string().nullish(),
  })
  .strict();

export const steelAssemblyBatchCreateInput = z.object({
  items: z.array(steelAssemblyCreateInput).min(1),
});

export type SteelAssemblyCreateInput = z.infer<typeof steelAssemblyCreateInput>;
export type SteelAssemblyBatchCreateInput = z.infer<
  typeof steelAssemblyBatchCreateInput
>;
